import { Component, OnInit,Input, Output, EventEmitter } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
import { SelectValueAccessor } from '@ionic/angular';

@Component({
  selector: 'app-questexte',
  templateUrl: './questexte.component.html',
  styleUrls: ['./questexte.component.scss'],
})
export class QuestexteComponent implements OnInit {


  @Input() id:number;
  @Input() edit:number;
  @Input() solution:string;

  texte:string;

  @Output() eventchild = new EventEmitter<string>();



  constructor(public gfichier : GfichierService) { }


  ngOnInit() {}

  ngOnChanges() {
    if(this.edit==0) this.texte=this.solution;
  }
  

  OnChange($event:String) {
    if(this.edit==0) this.gfichier.setValue($event,this.id,"quest");
    else if(this.edit==1) this.gfichier.setValue($event,this.id,"rep");
     
  }

}
